module.exports = __webpack_public_path__ + "assets/img/2812.40bb5259.png";